export const CREATE_FORM_ELEMENTS = 'CREATE_FORM_ELEMENTS'
export const ADD_MARKETING_ELEMENT = 'ADD_MARKETING_ELEMENT'
export const UPDATE_FORM = 'UPDATE_FORM'
export const UPDATE_FORM_ERRORS = 'UPDATE_FORM_ERRORS'
export const SET_REQUIRE_ADDRESS = 'SET_REQUIRE_ADDRESS'
export const INITIATISED = 'INITIATISED'
export const UNSET = 'UNSET'
export const VALID = 'VALID'
export const INVALID = 'INVALID'
export const SET_SHOW_USER_ERRORS = 'SET_SHOW_USER_ERRORS'
export const DEFAULT_CUSTOMER_TYPE = 'private'
export const OPTIN = 'optin'
export const MARKETING_CONSENT = 'marketingConsent'
export const MARKETING_CONSENT_POST = 'marketingConsentPost'
export const MARKETING_CONSENT_EMAIL = 'marketingConsentEmail'
export const ADDRESS_FINDER = 'address_finder'
export const POSTAL_CODE = 'postal_code'
export const SET_GOOGLE_ADDRESS_IS_OPEN = 'SET_GOOGLE_ADDRESS_IS_OPEN'

export const SUBMIT_REQUEST = 'SUBMIT_REQUEST'
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS'
export const SUBMIT_FAILURE = 'SUBMIT_FAILURE'

export const SHOW_FORM = 'SHOW_FORM'
export const SHOW_ERROR = 'SHOW_ERROR'
export const SHOW_SUCCESS = 'SHOW_SUCCESS'
export const SHOW_LOADER = 'SHOW_LOADER'

export const TEXT_INPUT_DYNAMIC_TEXT = 'text'
export const TEXT_INPUT_DYNAMIC_EMAIL = 'email'
export const TEXT_INPUT_DYNAMIC_PHONE = 'phone'
export const TEXT_INPUT_DYNAMIC_AREA = 'area'
export const TEXT_INPUT_DYNAMIC_CAR_REG = 'registration'
export const TEXT_INPUT_DYNAMIC_POSTCODE = 'postcode'
export const DROP_DOWN = 'DropDown'
